import { LocalizedName } from '../services/network'

export const SUPPORT_EMAIL_ADDRESS = process.env.REACT_APP_SUPPORT_EMAIL_ADDRESS || 'support@example.com'

export const languages: { code: keyof LocalizedName; name: string }[] = [
  { code: 'it', name: 'italian' },
  { code: 'en', name: 'english' }
]

export interface ICollapsedLangs {
  [key: string]: boolean
}

export interface ICategoryName {
  [key: string]: string
}

export interface IActivityName {
  [key: string]: string
}

export interface IRoleName {
  [key: string]: string
}
